/**
 * Musts of the Month Block.
 * 
 */

/**
 * Musts Slider.
 * Mobile: Fading single slide carousel.
 * Desktop: Fading single slide carousel.
 */

// Set up slick slider for Must slides.
let 
	inited = false,
	$window = $(window),
	$myMustsSlider = $('.promo-news-event__slides'),
    myMustsSliderSettings = {
        adaptiveHeight: true,
		arrows: false,
		autoplay: false,
		// autoplaySpeed: 3000,
    	// centerMode: true,
		// centerPadding:'30px',
    	// cssEase:'ease-out',
		dots: true,
		appendDots: $('.musts-block__dot-nav'),
		fade: true,
		// focusOnSelect:true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
		variableWidth: false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
				// settings: {
				// 	centerMode: false,
				// 	infinite: false,
				// 	slidesToShow: 3,
				// 	slidesToScroll: 1,
				// 	swipeToSlide: false,
				// }
			// }, {
			// 	breakpoint: 1350,
			// 	// settings: 'unslick'
			// 	// settings: {
			// 	// }
			}
        ]
    };

function initSlider() {
	console.log('MUSTS: initSlider()');
	$myMustsSlider.slick(myMustsSliderSettings);
	// if ($window.width() >= 1024) {
	// 	initDesktopSlider();
	// }
	inited = true;
}

function killSlider() {
	console.log('MUSTS: killSlider()');
	$myMustsSlider.slick('unslick');
}

function initFilter() {
	console.log('MUSTS: initFilter()');
	// Initialize Musts slide filter.
	let
		$excolButton		= $('.musts-block__filter-trigger.ex-col-button'),
		$excolPanel			= $('.musts-block__filter-panel.ex-col-panel'),
		$viewText			= $('.musts-block__filter-trigger h4'),
		$filterLinks		= $('.musts-block__filter-link'),
		$slidesContainer	= $('.promo-news-event__slides'),
		$slidesBank			= $('.slides-bank');

	$filterLinks.on('click', function() {
		var myType = $(this).data('type');
		// console.log('MUSTS: myType: '+myType);
		// $slides.find('.'+myType).css('display', 'none');
		filterSlides(myType);
		$excolButton.removeClass('expanded');
		$excolPanel.slideUp(300);
	});

	function filterSlides(type) {
		var $mySlides = $slidesBank.find('.'+type);
		if (inited) {
			killSlider();
		}
		if (['promo', 'event'].includes(type)) {
			type += 's';
		}
		$viewText.text('view ' + type);
		$slidesContainer.empty();
		$slidesContainer.append($mySlides.clone());

		initSlider();
	}

	filterSlides('all');
}

exports.init = function () {
	// console.log('COMMUNITY: exports.init');
	// Run init methods...

	initFilter();
	// initSlider();
};

